var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallWoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.62 238.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-6,.cls-2,.cls-3,.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-6,.cls-3{stroke:#0e090c;}.cls-6,.cls-7{fill:#0e090c;}.cls-2,.cls-4,.cls-5{stroke:#ea5599;}.cls-4{stroke-dasharray:0 0 5.03 5.03;}.cls-8{fill:#ebeaf4;}.cls-9{fill:#fff7d3;}.cls-10{fill:#d5dbe0;}.cls-5{stroke-dasharray:0 0 5 5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Farger"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.42,141.06c.83-.04,1.66-.11,2.49-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.88,140.09c11.79-2.46,22.7-9.28,30.09-19.98,15.29-22.12,9.75-52.46-12.37-67.75-18.97-13.11-43.97-10.91-60.36,3.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.43,58.03c-.59,.59-1.16,1.19-1.72,1.82"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M236.38,34.41c-4.15,9.36-11.81,27.3-13.82,47.22-2.81,27.73,.53,42.59,7.78,53.31,8.27,12.23,25.98,6.78,25.98,6.78l-4.61,19.65-28.81-3.84-43.48,26.78c-11.28-15.78-17.92-35.09-17.92-55.97,0-45.83,32-84.18,74.87-93.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.4,123.48c0,.07,0,.14-.01,.21,0-.06,0-.14,.01-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.39,123.73c0,.13-.01,.24-.02,.33,0-.1,.01-.21,.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.45,122.61c-.01,.22-.02,.42-.03,.6,.01-.18,.02-.39,.03-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.36,124.18c0,.07,0,.13,0,.17,0-.05,0-.1,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.21,108.24s0,.04,0,.06c0-.04,0-.06,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.2,108.37c-.05,1-.1,1.95-.15,2.85,.08-1.43,.13-2.5,.15-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.56,120.5c0,.05,0,.1,0,.16,0-.05,0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326,112.1c-.03,.55-.06,1.07-.08,1.58,.03-.55,.06-1.08,.08-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.69,117.95c-.04,.69-.07,1.31-.1,1.88,.03-.6,.07-1.23,.1-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.9,114.02c-.08,1.42-.14,2.68-.2,3.77,.07-1.25,.14-2.55,.2-3.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.82,162.78v-.05s18.56,4.57,18.56,4.57c-.02,.02-.03,.03-.03,.03l-18.54-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M327.55,166.61l16.81,4.14c6.29-12.8,9.82-27.19,9.82-42.41,0-15.4-3.34-31.13-10.75-43.85-1.92,3.59-2.72,7.73-3.96,13.32-1.45,6.56-.84,20.4,.98,30.31l-12.9,38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M294.21,109.36l22.54-17.22-7.42-41.29,2.88-2.03c10.76,7.37,19.95,16.86,26.96,27.88-4.32,.85-11.62,6.1-12.97,31.54,0,0-7.81-5.99-16.87-4.47-9.06,1.51-12.85,5.01-17.06,27.24l-11.52-4.08c1.07-3.08,1.57-5.27,2.85-9.18l10.61-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M300.93,176.65l-32.13-7.88s3.64-16.04,9.31-33.83c.35,.2,.71,.4,1.1,.6,10.23,5.22,35.35,18.28,35.35,18.28l-2.72,8.92-5.56-1.37-5.35,15.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.18,128.17c4.06-1.23,8.37-1.9,12.84-1.9,24.41,0,44.21,19.79,44.21,44.21,0,24.41-19.79,44.21-44.21,44.21-16.08,0-30.15-8.59-37.89-21.42,6.88-7.38,25.35-30.48,25.04-65.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M339.18,76.7c1.93,3.28,2.97,4.89,2.97,4.89,0,0-11.34-1.12-15.46,22.69-4.11,23.81,0,0,0,0l-1.83,1.27,4.27-31.03,10.04,2.18Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vektor"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 48.7,
    cy: 62.18,
    r: 48.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 84.55,
    cy: 109.36,
    r: 17.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.98,173.84c0,7.56-6.13,13.69-13.69,13.69-7.56,0-13.69-6.13-13.69-13.69,0-5.55,3.3-10.32,8.04-12.47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 442.29,
    cy: 97.81,
    r: 17.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.74,154.59s-25.96-14.87-32.63-18.12c-6.67-3.25-6.84-8.03-5.81-10.94l28.5,10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.21,108.24s.79-11.83,5.86-20.33c3.77-6.33,10.85-7.25,12.51-5.19,0,0-2.65,2.84-4.63,12.35-1.81,8.68-1.48,23.82,.51,33.05l-3.71,11.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 306.73,
    y1: 124.35,
    x2: 292.39,
    y2: 124.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 309.34,
    y1: 112.68,
    x2: 295.82,
    y2: 115.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "372.95 177.77 306.02 161.37 280.48 238"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 222.91,
    y1: 157.53,
    x2: 179.25,
    y2: 184.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 210.92,
    y1: 183.19,
    x2: 200.06,
    y2: 205.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.38,134.94c-7.43,5.38-15.07,9.49-26.57,7.4-25.83-4.68-23.66-62.35-10.84-94.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.79,168.77s3.02-14.63,9.31-33.83l36.45,18.88-2.73,8.96-5.54-1.42-5.35,15.28-32.13-7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.05,111.94l20.28-3.01s-8.84,21.21-15.77,10.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "244.69 102.18 238.62 100.37 248 73.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "265.44 88.6 257.92 82.08 272.41 81.59"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 237.51,
    cy: 76.54,
    r: 2.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.58,76.16s-1.83-6.9-11.61-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.72,161.37l4.61-19.65s-19.36,6.99-27.7-9.35c0,0-23,9.58-18.08,32.68l12.37-7.51,28.81,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.87,92.39c-6.42-7.29-6.63-17.19-5.29-26.4,2-13.75,3.09-27.05-6.73-38.43-7.03-8.14-24.52-20.46-57.92-9.39-27.5,9.11-39.45,33.72-39.45,33.72,18.89-.51,36.12,9.22,46.27,12.73,20.14,6.96,24.93-1.18,31.99-8.94,0,0-8.57,9.22-9.19,28.15-.61,18.56-11.16,22.26-16.06,32.98-4.69,10.25-1.72,23.5-1.69,28.13,.12,16.43-10,21.54-7.8,39.36,1.24,10,7.71,21.69,26.3,24.27l13.31-39.56-14.68-28.47s-7.18-4.8-9.35-6.43-3.22-4.91-2.27-8.58l18.31,6.19s-.23-26.71,17.45-27.58c0,0,7-.2,13.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.06,205.43c16.1,12.09,36.1,19.25,57.78,19.25,36.09,0,67.54-19.85,84.05-49.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.14,177.77c5.51,9.19,12.5,17.39,20.65,24.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.32,123.86c-46.63,0-73.54-47.06-73.54-88.63S157.34-1.53,161.51,4.33c4.17,5.86,5.95,20.25,0,33.57-5.95,13.32-23.54,37.67-61.37,35.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.79,103.13c5.04-.29,7.88,.67,10.31,1.64,0,0,5.66-12.31,3.18-23.33-2.47-11.03-10.86,7.85-10.86,7.85l-2.63,13.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.01,166.69l30.14,7.45s6.71-7.3,6.71-21.07c0-7.04-1.37-26.89-25.41-51.54,0,0-.61,6.82-.52,11.35,.25,13.38-1.62,21.16-4.69,32.31-5.26,19.05-6.22,21.49-6.22,21.49Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWoman);
export default __webpack_public_path__ + "static/media/Call_woman.65c00bfba43105f68de7e9fd1a93fbae.svg";
export { ForwardRef as ReactComponent };